/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/KeesingGames/theme';

export const KeesingGamesTheme = theme;
